var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCampaignLinkedin = function SvgCampaignLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none",
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.334.334H1.331c-.55 0-.997.453-.997 1.01v11.98c0 .557.447 1.01.997 1.01h12.003c.55 0 1-.453 1-1.01V1.345c0-.557-.45-1.01-1-1.01m-8.769 12H2.49V5.653h2.078v6.681zM3.528 4.74a1.204 1.204 0 1 1 0-2.407 1.204 1.204 0 0 1 0 2.407m8.815 7.594h-2.075v-3.25c0-.775-.015-1.772-1.078-1.772-1.081 0-1.247.844-1.247 1.716v3.306H5.868V5.653H7.86v.912h.028c.278-.525.956-1.078 1.966-1.078 2.1 0 2.49 1.384 2.49 3.184z"
  })));
};
export default SvgCampaignLinkedin;